import { authConfig } from '@/libs/auth-config';
import api from '@/libs/axiosInstance';
import { tokenManager, type AuthTokens } from '@/libs/token-manager';
import { useMutation } from '@tanstack/react-query';
import { resetProductAnalytics } from '@/libs/product-analytics';

export interface LoginCredentials {
  email: string;
  password: string;
}

const loginRequest = async (credentials: LoginCredentials): Promise<AuthTokens> => {
  // Perform the login - the backend now returns only tokens
  const { data: response } = await api.post(authConfig.endpoints.login, credentials);

  // Extract tokens from the login response
  const tokens = response.data;

  // Store tokens in token manager
  resetProductAnalytics();
  tokenManager.setTokens(tokens);

  console.log('[LOGIN] Tokens stored successfully');

  // Return the tokens - frontend should call /auth/me separately for user data
  return tokens;
};

export const useLoginAction = () =>
  useMutation<AuthTokens, Error, LoginCredentials>({
    mutationFn: loginRequest,
  });
